import React from 'react';
import { browserHistory } from 'react-router';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';
import Button from '../../../core/form/Button';
import BannerListContainer from './BannerListContainer';
import BannerListFilterContainer from './BannerListFilterContainer';

const BannerListScene = (props) => {
  return (
    <>
      <Breadcrumb
        crumbs={[
          ...(props.location.state && props.location.state.from
            ? [{ text: props.location.state.from.text, link: props.location.state.from.pathname }]
            : []),
          { text: 'Banners' },
        ]}
      />
      <Card
        title='Banners'
        actions={
          <Button
            type='primary'
            icon='plus'
            label='New Banner'
            onClick={() =>
              browserHistory.push({
                pathname: '/banners/new',
                state: { from: { text: 'Banners', pathname: '/banners' } },
              })
            }
          />
        }
      >
        <BannerListFilterContainer />
        <BannerListContainer />
      </Card>
    </>
  );
};

export default BannerListScene;
